import Link from 'next/link';
import {useRouter} from 'next/router';
import React from 'react';

import {
    CertificationAggregatorApi,
    CertificationTopic,
    PaginatedContent,
    CertificationTopicCarousel,
} from '@udemy/browse-aggregator';
import {useI18n} from '@udemy/i18n';

import {useCertificationBrowseAggregatorContext} from 'src/contexts/certification-browse-page-content-context';
import {udemyApi} from 'src/lib/ud-global-fetch';

import {CARD_CAROUSEL_PAGE_SIZE, MAX_CARDS_ON_STACKED_VIEW} from '../../certification-aggregator';

export const CertificationTopicCarouselWrapper = (props: {
    initialData: PaginatedContent<CertificationTopic>;
}) => {
    const {initialData} = props;
    const {gettext} = useI18n();
    const certificationAggregatorContext = useCertificationBrowseAggregatorContext();
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);
    const router = useRouter();

    const title = gettext('In Demand Certifications');

    const subtitle = gettext(
        'Dive into Top Certifications that learners on Udemy are preparing for',
    );

    /**
     * Note: key is added to force re-render the component when the route changes. It's necessary to update the content
     * when you're using <Link/> from next.js to navigate to the same page.
     *
     * Note: Using Link will enable prefetching + much faster page navigation
     */
    if (certificationAggregatorContext?.assignedEntities?.topicDescriptor?.entity_value) {
        return (
            <CertificationTopicCarousel
                key={`${router.asPath}-top-certification-topic-carousel`}
                title={title}
                subtitle={subtitle}
                fetchBy={'by_descriptor_id'}
                fetchByValue={
                    certificationAggregatorContext.assignedEntities?.topicDescriptor.entity_value
                }
                certificationAggregatorApi={certificationAggregatorApi}
                useStackedCards={true}
                stackedCardsProps={{
                    maxCards: MAX_CARDS_ON_STACKED_VIEW,
                }}
                initialData={initialData}
                pageSize={CARD_CAROUSEL_PAGE_SIZE}
                aggregatorCardProps={{
                    linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                        <Link {...props} legacyBehavior={false}>
                            {props.children}
                        </Link>
                    ),
                }}
            />
        );
    } else {
        return null;
    }
};
